var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"id":"ssoAccess","method":"post","action":_vm.ssoReturn}},[_c('input',{attrs:{"id":"tokenInput","type":"hidden","name":"jwt"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }